import Entity from "components/AddRemoveTableSortable/types/Entity"

const sortEntitiesByParent = <T extends Entity>(entities: T[]): T[] => {
  const entityMap = new Map<number, Entity>()
  const childrenMap = new Map<number, Entity[]>()

  const result: Entity[] = []

  for (const entity of entities) {
    entityMap.set(entity.id, entity)
    if (entity.parent_id != null) {
      if (!childrenMap.has(entity.parent_id)) {
        childrenMap.set(entity.parent_id, [])
      }
      childrenMap.get(entity.parent_id)!.push(entity)
    }
  }

  const addEntityAndChildren = (entity: Entity) => {
    result.push(entity)
    const children = childrenMap.get(entity.id)
    if (children) {
      children.sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
      for (const child of children) {
        addEntityAndChildren(child)
      }
    }
  }

  const roots = entities.filter(e => e.parent_id == null)
  roots.sort((a, b) => (a.order ?? 0) - (b.order ?? 0)) 

  for (const root of roots) {
    addEntityAndChildren(root)
  }

  return result as T[]
}

export default sortEntitiesByParent